<template>
  <svg
    class="mt-8"
    width="138"
    height="154"
    viewBox="0 0 138 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.54691 9.66605C2.18199 10.4718 0.5 12.7129 0.5 15.1931C0.5 73.9133 0.5 120.295 66.3379 152.526C67.1473 152.916 68.0325 153.118 68.9052 153.118C69.7778 153.118 70.8654 152.929 71.6621 152.538C137.298 120.761 137.5 74.3918 137.5 15.6967V15.4197C137.5 12.2092 134.68 9.61569 131.455 9.61569C110.398 9.61569 89.7087 6.46816 70.1572 0.273835C69.019 -0.0912782 67.7417 -0.0912782 66.6035 0.273835C47.1152 6.30449 26.8554 9.36389 6.44388 9.36389C5.81155 9.36389 5.15393 9.4772 4.54691 9.67864V9.66605ZM68.9178 140.817C14.1077 112.854 12.236 73.9637 12.1728 20.8964C31.1932 20.3928 50.0239 17.3712 68.2602 11.8945C86.6103 17.5349 105.808 20.6446 125.41 21.1608C125.359 74.291 123.564 113.22 68.9178 140.817Z"
      fill="#048B70"
    />
    <path
      d="M38.1713 49.1684C33.6333 53.8084 31.1235 60.0295 31.1235 66.6655C31.1235 73.3014 33.6333 79.5096 38.1713 84.1496L63.5864 109.514C64.7272 110.654 66.2103 111.212 67.6807 111.212C67.9469 111.212 68.2131 111.212 68.4793 111.16C70.013 111.238 71.5975 110.654 72.7891 109.462L98.1661 84.0978C107.622 74.429 107.622 58.7853 98.2169 49.1684C90.0663 40.8346 77.4918 39.6681 68.1877 45.6949C58.8836 39.6681 46.3092 40.8346 38.1713 49.1684Z"
      fill="#048B70"
    />
  </svg>
</template>
<script setup lang="ts"></script>
